import styled from 'styled-components';

export const H1Dashboard = styled.h1`
  font-size: 24px;
  line-height: 37px;
  font-weight: 500;
  margin: ${({ margin }) => margin || '10px 0 20px'};
  display: block;
`;
